import Link from "next/link";

export function Footer() {
  return (
    <footer className="border-t border-slate-800 py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-slate-400 text-sm">
            &copy; 2026 LeadSpector. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link href="/" className="text-slate-400 hover:text-white text-sm">
              Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
